import React, { FC, useEffect } from 'react';
import { usePublicFeedbackState } from '../../providers/PublicFeedback';
import FeedbackTab from './FeedbackTab';
import FeedbackType from './FeedbackType';
import CreateTaskModal from './CreateTaskModal';
import styles from './styles.module.css';
import modalStyles from './ModalLayout/index.module.css';
import cx from 'classnames';
import '../../../assets/stylesheets/shared/color-variables.css';

type Props = {};

const PublicFeedback: FC<Props> = () => {
  const {
    feedbackState,
    cancel,
    customFeedbackId,
    setFeedbackState,
    hideFader
  } = usePublicFeedbackState();

  const handleCancel = (event: KeyboardEvent) =>
    event.code === 'Escape' ? cancel() : null;

  useEffect(() => {
    window.addEventListener('keydown', handleCancel);

    let element: HTMLElement | null = null;
    const showFeedbackType = () => setFeedbackState('TYPE');

    if (customFeedbackId) {
      element = window.document.getElementById(customFeedbackId);
      if (element) element.addEventListener('click', showFeedbackType);
    }

    return () => {
      window.removeEventListener('keydown', handleCancel);
      if (element) element.removeEventListener('click', showFeedbackType);
    };
  }, []);

  let content;
  switch (feedbackState) {
    case 'TAB':
      content = <FeedbackTab />;
      break;
    case 'TYPE':
      content = <FeedbackType />;
      break;
    default:
      content = <CreateTaskModal />;
  }

  return (
    <div
      id="sidebarOuter"
      className={cx(styles.publicFeedbackOuter, {
        [modalStyles.hideFader]: hideFader
      })}
    >
      {content}
    </div>
  );
};

export default PublicFeedback;
